import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Music2, ArrowUpRight } from "lucide-react";
import { HERBALIFE_STORE_URL } from "@/constants/products";

// Social profile URLs — replace each "#" with your exact profile link when ready.
const SOCIALS = [
  { label: "TikTok", handle: "@flyingwithshelly", url: "https://www.tiktok.com/@flyingwithshelly", icon: Music2, testid: "social-tiktok-link" },
  { label: "Instagram", handle: "@flywithshelly", url: "https://www.instagram.com/flywithshelly", icon: Instagram, testid: "social-instagram-link" },
  { label: "Facebook", handle: "@flywithshelly", url: "https://www.facebook.com/flywithshelly", icon: Facebook, testid: "social-facebook-link" },
  { label: "YouTube", handle: "@flywithshelly", url: "https://youtube.com/@flywithshelly", icon: Youtube, testid: "social-youtube-link" },
];

const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-forest/10 bg-forest px-6 py-16 text-bone">
    <div className="mx-auto max-w-7xl">
      <div className="flex flex-col items-center gap-10 text-center md:flex-row md:items-start md:justify-between md:text-left">
        <div>
          <div className="flex items-center justify-center md:justify-start">
            <img src="/logo.png" alt="FitBunnyCat — Fit Bunny Cat logo" className="h-20 w-20 rounded-full shadow-lg" />
          </div>
          <p className="mt-2 font-display text-xs font-semibold tracking-[0.25em] text-bone/60">
            WELLNESS • FITNESS • LIFESTYLE
          </p>
          <nav className="mt-6 flex flex-col gap-2.5 font-display text-xs font-semibold tracking-[0.2em]">
            <Link to="/" data-testid="footer-home-link" className="text-bone/80 transition-colors hover:text-coral">Home</Link>
            <Link to="/shop" data-testid="footer-shop-link" className="text-bone/80 transition-colors hover:text-coral">Shop My Favorites</Link>
            <Link to="/journey" data-testid="footer-journey-link" className="text-bone/80 transition-colors hover:text-coral">My Journey</Link>
            <Link to="/get-started" data-testid="footer-get-started-link" className="text-bone/80 transition-colors hover:text-coral">Get Started</Link>
            <Link to="/merch" data-testid="footer-merch-link" className="text-bone/80 transition-colors hover:text-coral">Merch</Link>
          </nav>
        </div>

        <div className="flex flex-col items-center gap-8">
          <a
            href={HERBALIFE_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-shop-herbalife-button"
            className="inline-flex items-center gap-2 rounded-full bg-coral px-9 py-4 font-display text-sm font-bold tracking-[0.15em] text-bone transition-all duration-300 hover:scale-105 hover:bg-coraldark"
          >
            SHOP MY HERBALIFE WEBSITE
            <ArrowUpRight className="h-4 w-4" />
          </a>

          <div className="flex items-center gap-4">
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={s.testid}
                aria-label={`${s.label} — ${s.handle}`}
                title={`${s.label} — ${s.handle}`}
                className="flex h-12 w-12 items-center justify-center rounded-full border border-bone/25 text-bone/80 transition-all duration-300 hover:scale-110 hover:border-coral hover:text-coral"
              >
                <s.icon className="h-5 w-5" strokeWidth={1.8} />
              </a>
            ))}
          </div>
          <p className="font-body text-xs font-light text-bone/50">TikTok @flyingwithshelly • Instagram, Facebook & YouTube @flywithshelly</p>
        </div>
      </div>

      <p data-testid="footer-disclaimer" className="mx-auto mt-14 max-w-3xl border-t border-bone/10 pt-8 text-center font-body text-xs font-light leading-relaxed text-bone/50">
        FitbunnyCat.com is a personal wellness/product recommendation website. Product information, pricing, availability, discounts, membership terms and benefits are subject to Herbalife's current policies and may change. This website does not provide medical advice.
      </p>
      <p className="mt-4 text-center font-body text-xs font-light text-bone/40">
        © {new Date().getFullYear()} FitbunnyCat
      </p>
    </div>
  </footer>
);

export default Footer;
